import React from 'react';
import PdfViewer from '../../../components/shared/PdfViewer';
import { reportService } from "../../../services/domain/report/service";
import {EventPdfViewerProps} from "../../../model/event/ui/pdf-viewer-props";

/**
 * 專委會成員報表PDF預覽元件
 * Wrapper around the shared PdfViewer component with committee-specific functionality
 */
const EventPdfViewer: React.FC<EventPdfViewerProps> = ({
  visible,
  onClose,
  apiParam
}) => {
  /**
   * Load committee PDF data
   */
  const loadPdfData = async () => {
    // In a real implementation, we would pass committeeId and memberIds
    // to a specific report service function
    return await reportService.getMembershipNametagPdf({
      "membershipIds": apiParam.membershipIds,
      "type": apiParam.identityType,
      "order": "MEMBER_ID",
      "language": apiParam.language
    });
  };

  /**
   * Export PDF
   */
  const exportPdf = async (filename: string) => {
    // Here we would normally use a committee-specific export function
    // that would use the committeeId and memberIds
    await reportService.exportMembershipNametagPdf({
      "membershipIds": apiParam.membershipIds,
      "type": apiParam.identityType,
      "order": "MEMBER_ID",
      "language": apiParam.language
    });
  };

  /**
   * Export Excel
   */
  const exportExcel = async (filename: string) => {
    // Here we would normally use a committee-specific export function
    // that would use the committeeId and memberIds
    await reportService.exportMembershipNametagExcel({
      "membershipIds": apiParam.membershipIds,
      "type": apiParam.identityType,
      "order": "MEMBER_ID",
      "language": apiParam.language
    });
  };

  return (
    <PdfViewer
      visible={visible}
      onClose={onClose}
      title={`活動報表 (預覽)`}
      loadPdfData={loadPdfData}
      exportPdf={exportPdf}
      exportExcel={exportExcel}
    />
  );
};

export default EventPdfViewer;
